<div [ngStyle]="{ 'padding-left.px': getPaddingDepth(reply.reply_depth) * 16 }" class="border-start ps-3 pt-2 mt-2">
  <!-- Header -->
  <div class="d-flex align-items-center mb-2 cursor-pointer" (click)="openProfile(reply.Users?.id || reply.user_id)">
    <img [src]="reply.Users?.Jobseekers?.[0]?.avatar_url || 'https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Sign-Up-Image.jpg'" class="rounded-circle me-2" width="32" height="32" />
    
    <div>
     
      <div class="d-flex align-items-center gap-2 flex-wrap">
        <strong class="fw-semibold text-primary mb-0">
          {{ reply.Users?.Jobseekers?.[0]?.name || 'Anonymous' }}
        </strong>
  
        <span 
          class="badge rounded-pill px-2 py-1"
          [ngClass]="getAvailabilityBadgeClass(reply.Users.Jobseekers[0].availability)"
          *ngIf="reply.Users?.Jobseekers?.[0]?.availability">
          {{ getAvailabilityStatus(reply.Users.Jobseekers[0].availability) }}
        </span>
      </div>
  
      <!-- Designation -->
      <span class="text-secondary d-block" *ngIf="reply.Users?.Jobseekers?.[0]?.designation">
        {{ reply.Users.Jobseekers[0].designation }}
      </span>
  
      <!-- Date -->
      <small class="text-muted">{{ reply.created_at | timeAgoOrDate }}</small>
    </div>
  </div>
  
  

  <!-- Content -->
  <div class="mb-2">
    <span *ngIf="!expanded">
      <span class="rich-text" [innerHTML]="sanitizeAndLinkify(reply.content, 400)"></span>
      <span *ngIf="reply.content.length > 400">
        ... <a (click)="toggleExpand()" class="text-primary text-decoration-none">See more</a>
      </span>
    </span>
    <span *ngIf="expanded">
      <span class="rich-text" [innerHTML]="sanitizeAndLinkify(reply.content)"></span>
      <a (click)="toggleExpand()" class="text-primary text-decoration-none ms-2">See less</a>
    </span>
  </div>

  <!-- Attachments -->
  <div *ngIf="reply.CommunityPostAttachment?.length" class="row g-2 mb-2">
    <div class="col-4 col-sm-3 col-md-2" *ngFor="let att of reply.CommunityPostAttachment; let i = index">
      <img [src]="att.thumbnail_url || att.file_url" class="img-thumbnail cursor-pointer"
           (click)="openImageViewer(reply.CommunityPostAttachment, i)" />
    </div>
  </div>

  <!-- Actions -->
  <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
    <button *ngIf="reply.reply_depth < 4" class="btn btn-sm btn-outline-primary" (click)="replying = !replying">Reply</button>
    <button *ngIf="reply.replies?.length" class="btn btn-sm btn-link text-decoration-none text-muted" (click)="showReplies = !showReplies">
      <i class="bi" [ngClass]="showReplies ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      {{ showReplies ? 'Hide Replies' : 'Show Replies (' + reply.replies.length + ')' }}
    </button>
  </div>

  <!-- Reply Form -->
  <div *ngIf="replying" class="mt-2" [@slideIn]>
    <div *ngIf="submitting" class="text-center my-2">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Submitting...</span></div>
    </div>

    <ng-container *ngIf="!submitting">
      <textarea [(ngModel)]="replyContent" class="form-control mb-2" rows="3" maxlength="1000"
                placeholder="Write your reply..." style="resize: none;"></textarea>
      <small class="text-muted d-block text-end">{{ replyContent.length || 0 }}/1000 characters</small>

      <div class="mb-2">
        <i class="bi bi-image fs-4 text-primary cursor-pointer" (click)="uploadInput.click()" title="Upload Images"></i>
        <input type="file" #uploadInput hidden multiple accept="image/*" (change)="onFileChange($event)" />
        <small class="text-danger" *ngIf="imageError">{{ imageError }}</small>

        <div *ngIf="isGeneratingPreview" class="text-center my-2">
          <div class="spinner-border text-secondary" role="status"><span class="visually-hidden">Generating...</span></div>
        </div>

        <div class="mt-2 d-flex flex-wrap gap-2">
          <div *ngFor="let img of imagePreviews; let i = index" class="position-relative image-preview-wrapper">
            <img [src]="img" class="preview-image cursor-pointer" />
            <button
              type="button"
              class="btn btn-sm btn-danger delete-btn"
              (click)="removeImage(i)"
              title="Remove"
            >
              ×
            </button>
          </div>
        </div>
        
      </div>

      <button class="btn btn-sm btn-lite-blue me-2"
              (click)="submitReply()"
              [disabled]="!replyContent.trim() && imagePreviews.length === 0">
        Submit
      </button>
      <button class="btn btn-sm btn-secondary" (click)="replying = false">Cancel</button>
    </ng-container>
  </div>

  <!-- Recursive Replies -->
  <div *ngIf="reply.replies?.length && showReplies" class="mt-2" [@fadeStagger]>
    <app-reply-item
      *ngFor="let nested of reply.replies"
      [reply]="nested"
      [isMobile]="isMobile"
      [communityID]="communityID"
      (submitReplyToReply)="submitReplyToReply.emit($event)"
      [availabiltyDurations]="availabiltyDurations" >
    </app-reply-item>
  </div>
</div>

<ng-template #imageModal let-modal>
  <div class="modal-body text-center p-0">
    <img [src]="imageViewer?.current" class="img-fluid w-100 swipe-img" (swipeleft)="nextImage()" (swiperight)="prevImage()" />
  </div>
  <div class="modal-footer justify-content-between border-0">
    <button class="btn btn-link" (click)="prevImage()" [disabled]="!hasPrev()">Prev</button>
    <button class="btn btn-link" (click)="nextImage()" [disabled]="!hasNext()">Next</button>
    <button class="btn btn-danger btn-sm" (click)="imageModalRef?.close()">Close</button>
  </div>
</ng-template>


<!-- Profile Modal -->
<ng-template #profileModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title fw-semibold">
      {{ selectedUser?.is_public ? selectedUser?.name : 'Private User' }}
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-column align-items-center text-center">
      <img
        [src]="selectedUser?.is_public && selectedUser?.avatar_url ? selectedUser.avatar_url : 'logo/logo.png'"
        class="rounded-circle shadow mb-3"
        style="width: 100px; height: 100px;" />

      <ng-container *ngIf="selectedUser?.is_public; else privateProfile">

        <!-- <p><i class="bi bi-envelope-fill me-2 text-primary"></i>
          <strong>Email:</strong> {{ selectedUser?.email }}
        </p> -->

        <!-- <p *ngIf="selectedUser?.phone">
          <i class="bi bi-telephone-fill me-2 text-success"></i>
          <strong>Phone:</strong> {{ selectedUser.phone }}
        </p> -->
        
        <p *ngIf="selectedUser?.about_me">
          <i class="bi bi-person-lines-fill me-2 text-info"></i>
          <strong>About Me:</strong><br />
          <span class="d-block mt-1">{{ selectedUser.about_me }}</span>
        </p>
        

        <div *ngIf="selectedUser?.availability" class="mb-3">
          <p class="mb-0">
            <strong>Availability:</strong>
            {{ getAvailabilityStatus(selectedUser.availability) }}
          </p>
        </div>
        <!-- <div *ngIf="resumeViewerUrl; else noResume" class="w-100">
          <p><strong>Resume:</strong></p>
          <div class="border rounded shadow-sm overflow-hidden w-100" style="height: 500px;">
            <ngx-doc-viewer
              [url]="resumeViewerUrl"
              [viewer]="'google'"
              style="width: 100%; height: 100%; border: none;">
            </ngx-doc-viewer>
          </div>
        </div> -->
        

        <!-- <ng-template #noResume>
          <p class="text-muted fst-italic">No resume provided.</p>
        </ng-template> -->
      </ng-container>

      <ng-template #privateProfile>
        <div class="alert alert-warning w-100 mt-2 text-center">
          This profile is private.
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>